import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { AnalyticsService } from '@sm360/widget-commons-general';
import { Vehicle } from '@sm360/widget-commons-vehicle';

import VehicleCriteriaModel from 'inventory-listing/models/VehicleCriteriaModel.js';

function HocWithAnalytics(WrappedComponent) {
    class withAnalytics extends Component {
        constructor(props) {
            super(props);

            this.state = {
                trackingExecuted: false,
            };

            this.pushToDataLayer = this.pushToDataLayer.bind(this);
        }

        componentDidMount() {
            this.pushToDataLayer(this.props.vehicleCriteria, this.props.vehicles);
        }

        componentWillReceiveProps(nextProps) {
            this.pushToDataLayer(nextProps.vehicleCriteria, nextProps.vehicles);
        }

        pushToDataLayer(vehicleCriteria, vehicles) {
            if (
                isEmpty(vehicles) ||
                !vehicleCriteria ||
                !vehicleCriteria.colanderSlug ||
                !vehicleCriteria.category ||
                this.state.trackingExecuted
            ) {
                return;
            }

            const params = {
                condition: vehicleCriteria.colanderSlug.toLowerCase(),
                vehicleCategory: vehicleCriteria.category.toLowerCase(),
                carIds: JSON.stringify(vehicles.map((vehicle) => `${vehicle.vehicleId}`)),
            };

            AnalyticsService.pushToDataLayer('inventory-listing', params);
            this.setState({ trackingExecuted: true });
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }

    withAnalytics.defaultProps = {
        vehicles: [],
    };

    withAnalytics.propTypes = {
        vehicleCriteria: PropTypes.arrayOf(PropTypes.instanceOf(VehicleCriteriaModel)).isRequired,
        vehicles: PropTypes.arrayOf(PropTypes.instanceOf(Vehicle.VehicleModelV25)),
    };

    withAnalytics.displayName = 'withAnalytics';

    return withAnalytics;
}

HocWithAnalytics.displayName = 'HocWithAnalytics';

export default HocWithAnalytics;
